import { render } from "./ProjectStatistic.vue?vue&type=template&id=6361bdcd&scoped=true"
import script from "./ProjectStatistic.vue?vue&type=script&lang=js"
export * from "./ProjectStatistic.vue?vue&type=script&lang=js"

import "./ProjectStatistic.vue?vue&type=style&index=0&id=6361bdcd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6361bdcd"]])

export default __exports__